<template>
  <div
    class="menu-filters"
    :class="{
      'menu-filters--controls-enabled':
        $store.getters.functionalityOrderEnabled ||
        $store.getters.functionalityPayGoEnabled,
    }"
  >
    <MenuHeader
      :show-back="showBack"
      :on-back="goBack"
      :show-category-slider="false"
    />
    <LayoutCard
      v-if="displayFilters"
      rounded
      :hide-background="!!$store.getters.customizationMenuHideLayoutCards"
      :use-custom-background-color="true"
    >
      <v-row dense>
        <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
          <v-card
            class="menu-filters__card"
            flat
            height="100%"
            min-height="100%"
            rounded="lg"
            :cy-data="`menu-filter-${card.title}`"
            @click="() => onCardClick(card)"
          >
            <v-img
              :src="card.src"
              class="white--text align-end"
              :gradient="
                $store.getters.customizationMenuFilterCardsImageGradient
              "
              height="150px"
            >
            </v-img>
            <v-card-title
              class="tp-text-subtitle menu-filters__card-text"
              :class="{
                'menu-filters__card-text--center': !!$store.getters
                  .customizationMenuFilterCardsTextCenter,
              }"
            >
              {{ $t(card.title) }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </LayoutCard>
    <MoreInformation />
    <MenuControls />
  </div>
</template>

<script>
import LayoutCard from '@/components/LayoutCard.vue';
import MenuHeader from '@/components/Menu/MenuHeader.vue';
import MoreInformation from '@/components/MoreInformation.vue';
import MenuControls from '@/components/MenuControls.vue';

export default {
  components: {
    LayoutCard,
    MenuHeader,
    MoreInformation,
    MenuControls,
  },
  data() {
    return {
      pageTitle: 'Loading menu - Greet.menu',
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  computed: {
    session() {
      return this.$store.state.session;
    },
    filters() {
      return this.$store.getters.restaurantMenuFilters;
    },
    displayFilters() {
      return this.filters.length > 0;
    },
    cards() {
      return this.filters.map(filter => ({
        title: filter.name,
        src: filter.image,
        flex: filter.flex,
        categoryIds: filter.category_ids,
      }));
    },
    showBack() {
      return (
        this.$store.getters.functionalityShowSelectScreenEnabled ||
        this.$store.getters.functionalityPayGoEnabled
      );
    },
  },
  async mounted() {
    const sessionToken = this.$route.params.session;

    if (this.$store.state.restaurant.id === null) {
      await this.$store.dispatch('fetchSessionData', { session: sessionToken });
      this.pageTitle = this.$store.state.restaurant.name + ' - Greet.menu';
    }
  },
  methods: {
    onCardClick(filter) {
      this.$store.dispatch('setActiveMenuFilters', filter.categoryIds);

      this.$router.push({
        name: 'Menu',
        params: { session: this.session },
      });
    },
    goBack() {
      return this.$router.push({
        name: 'Select',
        params: { session: this.$store.state.session },
        replace: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-filters {
  width: 100vw;
  max-width: $max-app-width;
  margin-left: auto;
  margin-right: auto;
  background: var(--menu-background-image), var(--menu-background-color);
  background-position: top;
  background-size: cover;
  background-repeat: revert;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  &__card {
    background-color: var(--menu-filter-cards-color) !important;
  }
  &__card-text {
    color: var(--menu-filter-cards-text-color) !important;
    font-weight: var(--menu-filter-cards-font-weight) !important;
    font-size: var(--menu-filter-cards-font-size) !important;
    &--center {
      justify-content: center !important;
      text-align: center;
    }
    word-break: normal !important;
  }

  &--controls-enabled {
    padding-bottom: 88px;
  }
}
</style>
